<template>
  <v-menu
    v-model="menu"
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn rounded v-on="on" class="ma-1">
        <v-icon v-if="isSelected" left dark color="green">mdi-check</v-icon>
        <v-tooltip bottom v-if="isChildOnly">
          <template v-slot:activator="{ on }">
            <v-btn text color="blue" icon v-on="on" small
              ><v-icon small>mdi-alpha-c-circle-outline</v-icon></v-btn
            >
          </template>
          <span>Child Only</span>
        </v-tooltip>
        <v-tooltip bottom v-if="isInfantOnly">
          <template v-slot:activator="{ on }">
            <v-btn text color="pink" icon v-on="on" small
              ><v-icon small>mdi-alpha-i-circle-outline</v-icon></v-btn
            >
          </template>
          <span>Infant Only</span>
        </v-tooltip>
        {{ name }}&nbsp;-&nbsp;
        <strong>{{ price }}{{ currency }}</strong>
        &nbsp;{{ rateType }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h3 class="title">
          {{ name }}&nbsp;-&nbsp; {{ price }}{{ currency }} &nbsp;{{ rateType }}
        </h3>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field
              :label="qtyLabel"
              type="number"
              v-model="selectedQty"
              :min="minQty"
              :outlined="outlinedInputs"
              class="mr-2"
              :disabled="qtyDisabled"
              :max="maxQty"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <date-range-picker
              :gt-date-from-string="selectedStartDate"
              :range-start="rangeStart"
              :gt-date-to-string="selectedEndDate"
              :range-end="rangeEndByServiceType"
              @onRangeSelected="onDateRangeChange"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-flex>
        </v-layout>
        <v-row v-if="debug">
          <v-col>
            <code>{{ startDate }} -- {{ selectedStartDate }}</code>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn text @click="menu = false" color="warning">Cancel</v-btn>
        <v-btn color="primary" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DateRangePicker from "../../../shared/DatesRangePicker";
const moment = require("moment");
export default {
  name: "ItemExtrasListItem",
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    rateType: {
      type: String,
      required: true,
    },
    rateBase: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    rangeStart: {
      type: String,
    },
    rangeEnd: {
      type: String,
    },
    endDate: {
      type: String,
      required: true,
    },
    qty: {
      type: Number,
      default: () => 0,
    },
    serviceType: { type: String, default: () => "" },
    percentPrice: {
      type: Number,
      default: () => 0,
    },
    isMandatory: {
      type: Boolean,
      default: () => false,
    },
    isSelected: {
      type: Boolean,
      default: () => false,
    },
    maxPax: {
      type: Number,
      default: () => 999,
    },
    isChildOnly: {
      type: Boolean,
      default: () => false,
    },
    isInfantOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { DateRangePicker },
  data() {
    return {
      debug: false,
      menu: false,
      selected: false,
      selectedQty: this.qty,
      selectedStartDate: this.startDate,
      selectedEndDate: this.endDate,
    };
  },

  computed: {
    qtyDisabled() {
      return false;
      //return this.isMandatory;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    minQty() {
      return this.isMandatory ? 1 : 0;
    },
    maxQty() {
      return this.rateBase == "P" ? this.maxPax : 1000;
    },
    qtyLabel() {
      return this.rateBase == "P" ? "Pax" : "Qty";
    },
    rangeEndByServiceType() {
      //return this.rangeEnd;
      return this.serviceType &&
        this.serviceType == "ACCOMMODATION" &&
        this.percentPrice > 0
        ? moment(this.rangeEnd).subtract(1, "day").toISOString(true)
        : this.rangeEnd;
    },
  },
  watch: {
    qty(newQty) {
      this.selectedQty = newQty;
      if (this.isMandatory) {
        this.onSave();
      }
    },
    startDate(newStart) {
      this.selectedStartDate = newStart;
    },
    endDate(newEnd) {
      this.selectedEndDate = newEnd;
    },
  },
  methods: {
    onDateRangeChange(payload) {
      //console.log("range change", payload);
      this.selectedStartDate = payload.dateFrom;
      this.selectedEndDate = payload.dateTo;
    },
    onSave() {
      this.menu = false;
      // console.log(
      //   "onSave",
      //   this.selectedStartDate,
      //   this.selectedEndDate,
      //   this.name,
      //   this.id
      // );
      if (this.selectedQty > 0) {
        this.$emit("select", {
          id: this.id,
          qty: Number(this.selectedQty),
          rateBase: this.rateBase,
          name: this.name,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          currencySell: this.currency,
        });
      } else {
        this.$emit("deselect", { id: this.id, name: this.name });
      }
    },
  },
  mounted() {
    //auto select mandatory extras
    if (this.isMandatory) {
      this.onSave();
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemExtrasListItem.vue